import * as THREE from 'three';

export default function useRenderer(element) {
  const renderer = new THREE.WebGLRenderer({
    alpha: true,
    antialias: true,
    gammaOutput: false,
    colorSpace: THREE.SRGBColorSpace,

    // Fixes material chipping issues, does not seem to affect performance much
    // SEE: https://threejs.org/examples/webgl_camera_logarithmicdepthbuffer.html
    logarithmicDepthBuffer: true,
  });

  // The +2 for width is a fix for a white line on the left in Safari
  renderer.setSize(element.offsetWidth + 2, element.offsetHeight);
  renderer.setClearColor(0x888888, 1);

  return renderer;
}
